import api from "@/services/api";
import type { UserPreferences, UpdateUserPreferencesDto } from "@/types/UserPreferences";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

type UserPreferencesResponse = {
  id: string;
  email: string;
  notifyStatusUpdates: boolean;
  notifyCityNews: boolean;
  notifyGovernmentReplies: boolean;
  notifyNeighborhoodNews: boolean;
};

export const useGetUserPreferences = () => {
  return useQuery({
    queryKey: ["userPreferences"],
    queryFn: async () => {
      const response = await api.get<UserPreferencesResponse>("/users/me/preferences");
      return {
        notifyStatusUpdates: response.data.notifyStatusUpdates,
        notifyCityNews: response.data.notifyCityNews,
        notifyGovernmentReplies: response.data.notifyGovernmentReplies,
        notifyNeighborhoodNews: response.data.notifyNeighborhoodNews,
      };
    },
  });
};

export const useUpdateUserPreferences = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["updateUserPreferences"],
    mutationFn: async (data: UpdateUserPreferencesDto) => {
      const response = await api.patch<UserPreferences>("/users/me/preferences", data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["userPreferences"] });
    },
  });
};
